import script from "./SignOutButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignOutButton.vue?vue&type=script&setup=true&lang=ts"

import "./SignOutButton.vue?vue&type=style&index=0&id=1345e30b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1345e30b"]])

export default __exports__